import { Instance } from 'mobx-state-tree';
import { VisitSchedulingDtoModelBase } from './VisitSchedulingDtoModel.base';

/* The TypeScript type of an instance of VisitSchedulingDtoModel */
export interface VisitSchedulingDtoModelType extends Instance<typeof VisitSchedulingDtoModel.Type> {}

/* A graphql query fragment builders for VisitSchedulingDtoModel */
export { selectFromVisitSchedulingDto, visitSchedulingDtoModelPrimitives, VisitSchedulingDtoModelSelector } from './VisitSchedulingDtoModel.base';

/**
 * VisitSchedulingDtoModel
 */
export const VisitSchedulingDtoModel = VisitSchedulingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
